<template>
    <div>
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-autocomplete
                        v-model="params.cityName"
                        size="small"
                        class="input-with-select"
                        :fetch-suggestions="remoteCity"
                    >
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="城市" :value="1"></el-option>
                        </el-select>
                    </el-autocomplete>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                   
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="params.time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        :clearable="false"
					        popper-class="el-date-picker_clearable"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示实际收入最多的" :value="1"></el-option>
                        <el-option label="优先展示总订单数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="exportData" :loading="exportDataLoading" icon="el-icon-download">导出</el-button>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-card v-loading="fetchStatisticsLoading" shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.cityNum || 0}}</p><p class="color-info">城市总数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.amount || '0.00'}}</p><p class="color-info">实际收入</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.djAmount || '0.00'}}</p><p class="color-info">独家演出实际收入</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tzAmount || '0.00'}}</p><p class="color-info">投资演出实际收入</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.orderNum || 0}}</p><p class="color-info">总订单数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.djOrderNum || 0}}</p><p class="color-info">独家演出订单数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tzOrderNum || 0}}</p><p class="color-info">投资演出订单数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.ticketNum || 0}}</p><p class="color-info">售票数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.djTicketNum || 0}}</p><p class="color-info">独家演出售票数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tzTicketNum || 0}}</p><p class="color-info">投资演出售票数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.activityNum || 0}}</p><p class="color-info">演出数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.djActivityNum || 0}}</p><p class="color-info">独家演出数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tzActivityNum || 0}}</p><p class="color-info">投资演出数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.discounts || '0.00'}}</p><p class="color-info">优惠金额</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.djDiscounts || '0.00'}}</p><p class="color-info">独家演出优惠金额</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tzDiscounts || '0.00'}}</p><p class="color-info">投资演出优惠金额</p></el-col>
                </el-row>
            </el-card>
        </template>
        <div class="page-group-title"><span>统计列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="amount" label="实际收入" :min-width="150">
                    <template slot-scope="scope">
                        <div>金额：{{scope.row.amount || '0.00'}}</div>
                        <div>占比：{{scope.row.rank || '0.0%'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="总订单数" :min-width="150"></el-table-column>
                <el-table-column prop="totalNum" label="售票数" :min-width="150"></el-table-column>
                <el-table-column prop="activityNum" label="演出数" :min-width="150"></el-table-column>
                <el-table-column prop="discounts" label="优惠金额" :min-width="150"></el-table-column>
                <el-table-column prop="djAmount" label="独家演出实际收入" :min-width="150"></el-table-column>
                <el-table-column prop="djOrderNum" label="独家演出订单数" :min-width="150"></el-table-column>
                <el-table-column prop="djTotalNum" label="独家演出售票数" :min-width="150"></el-table-column>
                <el-table-column prop="djActivityNum" label="独家演出数" :min-width="150"></el-table-column>
                <el-table-column prop="djDiscounts" label="独家演出优惠金额" :min-width="150"></el-table-column>
                <el-table-column prop="tzAmount" label="投资演出实际收入" :min-width="150"></el-table-column>
                <el-table-column prop="tzOrderNum" label="投资演出订单数" :min-width="150"></el-table-column>
                <el-table-column prop="tzTotalNum" label="投资演出售票数" :min-width="150"></el-table-column>
                <el-table-column prop="tzActivityNum" label="投资演出数" :min-width="150"></el-table-column>
                <el-table-column prop="tzDiscounts" label="投资演出优惠金额" :min-width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" :width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="toDate(scope.row)">查看日期明细</el-button>
                        <el-button size="small" type="text" @click="toStyle(scope.row)">查看风格明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import dayjs from 'dayjs';
import {downloadFileTmp} from '@/assets/js/commonApi.js';

export default {
    components:{Tab},
    data(){
        const date = new Date();

        const month = date.getMonth();
        const day = date.getDate();

        const start = new Date();
        const end = new Date();

        start.setMonth(month - 3, day + 1);
        start.setHours(0, 0, 0);

        end.setHours(23, 59, 59);

        this.defaultParams = {
            queryType: 1,
            cityName: null,
            timeStart: dayjs(start).format('YYYY-MM-DD HH:mm:ss'),
            timeEnd: dayjs(end).format('YYYY-MM-DD HH:mm:ss'),
            sort: 1,
            pageNo: 1,
			timeType:1,
            pageSize: this.$pageSizes[0]
        };

        const params = this.parsing();

        return{
            statistics: null,
            fetchStatisticsLoading: false,
            data: null,
            dataList: null,
            params: {...params},
            listLoading: false,
            filter: null,
            exportDataLoading: false  
        }
    },
    created() {
        this.$router.replace({path: '/report/sales/city', query: {...this.$route.query, t: Date.now()}});
        this.getStatistics();
    },
    watch: {
        '$route.query': function() {
            this.getDataList();
        }
    },
    methods:{
        parsing() {
            const {queryType, cityName, timeStart, timeEnd, sort, pageNo, pageSize} = {...this.defaultParams, ...this.$route.query};


            return {
                queryType: parseInt(queryType), 
                cityName, 
                time: [timeStart, timeEnd], 
                sort: parseInt(sort), 
                pageNo: parseInt(pageNo), 
                pageSize: parseInt(pageSize),
				timeType:1
            };
        },
        //获取列表
        async getDataList() {
            const {time, ...params} = this.parsing();
            const [timeStart, timeEnd] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/city/list',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...params, timeStart, timeEnd};
        },
         //选择pageSize
        pageSizeChange() {
            if(this.isTimeError()) return;

            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/city', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        pageNoChange() {
            if(this.isTimeError()) return;

            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/city', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        //搜索
        search() {
            if(this.isTimeError()) return;
            
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/city', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        //重置搜索
        reset() {
            const {timeStart, timeEnd, ...params} = this.defaultParams;
            this.params = {
                ...params,
                time: [timeStart, timeEnd],
            };
            this.$router.replace({path: '/report/sales/city', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        isTimeError() {
            const {time} = this.params;
            const [timeStart, timeEnd] = time || [];

            if(!timeStart || !timeEnd) {
                this.$alert('请选择时间范围', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            if(new Date(timeEnd).getTime() - new Date(timeStart).getTime() > 730 * 24 * 60 *60 *1000) {
                this.$alert('目前支持查询最多2年的数据', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            return false;
        },
        async getStatistics() {
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];


            this.fetchStatisticsLoading = true;

            const res = await this.$request({
                url: '/sales/city/statistics',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchStatisticsLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.statistics = result || {};
        },
        async remoteCity(q, cb) {
            const res = await this.$request({
                url: '/common/getCityByName',
                method: 'post',
                params: {keywords: q}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, result } = res.data;

            if(state !== '1') {
                cb([]);
                return ;
            }


            cb((result || []).map(item => ({value: item.name})));
        },
        // 导出
        async exportData() {
            const {filter} = this;

            if(!filter) {
                return this.$message.error('没有可以操作的数据');
            }

            this.exportDataLoading = true;

            const res = await this.$request({
                url:'/sales/city/export',
                method: 'post',
                data: filter,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.exportDataLoading = false;
            });

            const{state, msg, result} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '下载失败');
            }

            downloadFileTmp(result.url, '城市销售.xlsx');
        },
        toDate(row) {
            const {cityId} = row;
            const {timeStart, timeEnd} = this.filter;
            this.$router.push({path: '/report/sales/city/date', query: {cityId, timeStart, timeEnd}});
        },
        toStyle(row) {
            const {cityId} = row;
            const {timeStart, timeEnd} = this.filter;
            this.$router.push({path: '/report/sales/city/style', query: {cityId, timeStart, timeEnd}});
        }
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>